<template>
  <div class="diadin">
    <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item>
        <el-input style="width: 300px;" placeholder="请输入发货单号"
          v-model="title"></el-input>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="onSubmit">{{ $t('menu.search') }}</el-button>
      </el-form-item>
    </el-form>
 
    <el-table  empty-text=" " :data="mation" style="width: 100%" border highlight-current-row >
    
      <el-table-column prop="shippedTime" label="发货时间" width="200"> </el-table-column>
    
      <el-table-column prop="logisticsNumber" label="发货单号" >  </el-table-column>
      <el-table-column prop="logisticsOrderCode" label="关联配件订单" >
        <template slot-scope="scope">
          {{ scope.row.logisticsOrderCode }}
        </template>
      </el-table-column>
      <el-table-column prop="shippedQuantity" label="发货数量"></el-table-column>
      <el-table-column prop="shippedQuantity" label="发货配件数量"></el-table-column>
      <el-table-column prop="shippedQuantity" label="发货整车数量"></el-table-column>
      
     
    
      <el-table-column width="80">
        <template slot="header" slot-scope="scope">
          <div>{{ $t('menu.Operation') }}</div>
        </template>
        <template slot-scope="scope">
          <el-button type="text" size="mini" >导出</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="bottompage">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage3"
        :page-sizes="[10, 20, 50, 100]" :page-size="10" layout="total, prev, pager, next" :total="totale">
      </el-pagination>
    </div>

    <div></div>
  </div>
</template>

<script>
import { getPoShipments, exportMyPoDetails } from '../../api/api'

export default {
  data () {
    return {
      title:'',
      
      currentPage3: 1,
      pagesize: 10,
      totale: 3,
    
      mation: [], //列表
      formInline: {
        title: '',
           
      },
      inle: 'zh',
   
    }
  },
  created () {
    let a = sessionStorage.getItem('i18n')
    this.inle = a
    this.querytyp()
   
    this.biao()
  },
  methods: {
    downOrderDetails () {
    
      exportMyPoDetails(obj).then(res => {
        // const link = document.createElement('a')
        // let blob = new Blob([res.data], { type: 'application/x-www-form-urlencoded' })
        // link.style.display = 'none'
        // link.href = URL.createObjectURL(blob)
        // link.setAttribute('download', '我的采购订单明细.xlsx')
        // document.body.appendChild(link)
        // link.click() //触发下载
        // document.body.removeChild(link)

        // 创建一个URL对象，将Blob对象包装成一个临时的可访问URL
        const url = window.URL.createObjectURL(new Blob([res.data]));
        // 创建一个<a>元素，用于模拟点击下载文件
        const link = document.createElement('a');
        link.href = url;
        // 设置下载文件的名称
        link.setAttribute('download', '我的采购订单明细.xlsx');
        // 将<a>元素添加到文档中
        document.body.appendChild(link);
        // 模拟点击下载
        link.click();
        // 移除<a>元素
        // link.remove();
        // 释放创建的URL对象，避免内存泄漏
        window.URL.revokeObjectURL(url);
      })
    },
   
    async biao () {
     
      let param = new URLSearchParams()
   
      const { data: res } = await getPoShipments(
        param,
        this.currentPage3,
        this.pagesize,
         this.title
      )

      this.mation = res.data.list
      this.totale = res.data.total
    
    },
   
 
   
   

    //搜索
    onSubmit () {
      this.biao()
    },

    handleSizeChange (val) {
      this.pageSize = val
      console.log(`每页 ${val} 条`)
      this.biao()
    },
    handleCurrentChange (val) {
      this.currentPage3 = val
      this.biao()
    },
   
    
  },
}
</script>

<style lang="less" scoped>
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.diadin {
  width: 100%;
  min-height: 80vh;
  background-color: #fff;
  padding: 20px;
  padding-left: 0;
}

.bonntbot {
  padding-bottom: 10px;


  position: relative;


}

.bonntbota {
  position: absolute;
  right: 10px;
  top: 0;
}

.bottompage {
  display: flex;
  justify-content: flex-end;
  padding-top: 20px;
}

/deep/.el-table {
  min-height: 750px !important;
}

/deep/.el-table__body td {
  padding: 20px !important;
  padding-left: 0 !important;
  text-align: left;
}

/deep/.el-table th.is-leaf {
  text-align: left;
}

/deep/.el-tabs {
  height: 97%;
  width: 100%;
}

/deep/.el-tabs__content {
  width: 100%;
  height: 100%;
}

/deep/.el-table--scrollable-x .el-table__body-wrapper {
  height: 90%;
}

/deep/.el-tab-pane {
  height: 82%;
}

/deep/.el-table--fit {
  height: 94%;
}

.xz-box {
  width: 400px;
  margin: 0 auto;
}

.actio {
  color: #409eff;
  font-size: 16px;
  font-weight: 600;
}
</style>
